import { createTheme, lighten } from '@mui/material'

const defaultTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: "#FFB703",
      dark: "#FB8500"
    },
    background: {
      default: "#202B3C",
      paper: "#1B202C"
    }
  },
  typography: {
    fontFamily: "Noto Sans, sans-serif",
    fontSize: 10,
    button: {
      textTransform: "none",
      fontWeight: 700
    }
  },
  shape: {
    borderRadius: 10
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4
        },
        contained: ({ theme, ownerState }) => ({
          backgroundColor: theme.palette.background.default,
          "&:hover": { 
            backgroundColor: lighten(theme.palette.background.default, 0.02),
          },
          color: theme.palette.primary.main,
          fontSize: "1em",
          paddingLeft: "3em",
          paddingRight: "3em",
          height: 38,
          borderRadius: theme.shape.borderRadius
        }),
        containedSecondary: (({ theme }) => ({
          backgroundColor: theme.palette.background.paper,
          "&:hover": { 
            backgroundColor: lighten(theme.palette.background.paper, 0.02),
          },
        }))
      },
      defaultProps: {
        disableElevation: true
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          ".MuiSvgIcon-root": {
            width: "1.1em",
            height: "1.1em"
          }
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        paper: ({ theme }) => ({
          backgroundImage: "none",
          backgroundColor: theme.palette.background.default,
          padding: [ theme.spacing(1), theme.spacing(1) ].join(' '),
          
        })
      }
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: ({
          fontSize: 16,
          fontWeight: 700
        })
      }
    },
    MuiDialogActions: {
      styleOverrides: {
        root: ({
          justifyContent: "center",
          paddingBottom: 8
        })
      }
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: 38
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          paddingTop: 6,
          paddingBottom: 6,
          minHeight: 38,
          fontSize: 11 
        }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: 11,
          lineHeight: "18px",
          marginTop: '5px !important',
          marginBottom: '5px !important',
          backgroundColor: "#334867",
          maxWidth: 200,
          whiteSpace: "pre-wrap"
        },
        arrow: {
          color: "#334867"
        }
      }
    }
  }
})

export default defaultTheme